import { render, staticRenderFns } from "./RessifApexDonutChart.vue?vue&type=template&id=12e4f720&scoped=true&"
import script from "./RessifApexDonutChart.vue?vue&type=script&lang=ts&"
export * from "./RessifApexDonutChart.vue?vue&type=script&lang=ts&"
import style0 from "./RessifApexDonutChart.vue?vue&type=style&index=0&id=12e4f720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4f720",
  null
  
)

export default component.exports